import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { fromJS, Map, Record } from "immutable";
import { DateStringNumber } from "common/records";

export const analyticEventFromJSON = (json: Partial<IAnalyticEventData>): AnalyticEventRecord => {
  const record: IAnalyticEventRecord = { ...(json as any) };

  if (json.data) {
    record.data = fromJS(json.data);
  }

  if (json.inserted_at) {
    record.inserted_at = checkDate(json.inserted_at);
  }

  return new AnalyticEventRecord(record);
};

export interface IAnalyticEventData {
  id: number;
  environment: number;
  data: any;
  inserted_at: Nullable<DateStringNumber>;
}

export interface IAnalyticEventRecord {
  id: number;
  environment: number;
  data: Map<string, any>;
  inserted_at: Nullable<Date>;
  loading: boolean;
}

const defaultAnalyticEventProps: IAnalyticEventRecord = {
  id: -1,
  environment: -1,
  data: Map<string, any>(),
  inserted_at: null,
  loading: false,
};

export class AnalyticEventRecord extends Record(defaultAnalyticEventProps) implements IAnalyticEventRecord {}
